import jQuery from 'jquery';
import './chart/chart';
import './vendor/jquery/jquery.mask';
import { noDataloggerInfoWithLink, noDataloggerInfo } from './vcom/dataloggerAlert';
import addDefaultShortcuts from './vcom/shortcuts/addDefaultShortcuts';
import Base from './vcom/Base';
import VcomProvider from './VcomProvider';
import setupModal from './setupModal';
import modals from './modals';
import tourSetup from './vcom/tour/tourSetup';
import mcdatetimepickerInit from './vendor/jquery/timepicker/mcdatetimepickerInit';
import localizeHighcharts from './vendor/localizeHighcharts';
import localizeDatepicker from './vendor/localizeDatepicker';
import registerModalClickEvents from './modal/registerModalClickEvents';
import CyclingSystemsSwitch from './cyclingSystemsSwitch/CyclingSystemsSwitch';
import vueInstanceSetup from './vueInstanceSetup';
import PortletConstants from './portlet/PortletConstants';
import PortletFactoryRegistry from './portlet/PortletFactoryRegistry';
import PortletPool from './portlet/PortletPool';
import EventService from './common/event/EventService';
import ChangelogEvent from './vcom/events/ChangelogEvent';
import VcomSetupEvent from './vcom/events/VcomSetupEvent';
import showSystemLicenseEndingSoon from './vcom/systemLicenseEndingSoon';
import translate from './common/localization/translate';
import HttpService from './common/http/HttpService';
import Portal from './portal/portal';
import TranslationStore from './common/localization/TranslationStore';
import Sidebar from './vcom/Sidebar';
import UpdateService from './vcom/UpdateService';
import LanguageSwitch from './vcom/LanguageSwitch';
import Layout from './vcom/Layout';
import Locale from './common/localization/Locale';
import VcomHelperService from './vcom/VcomHelperService';
import SocketCenter from './common/socket/SocketCenter';
import administrationSetup from './administrationMenu/administrationSetup';
import TourService from './vcom/tour/tourService';
import installBeamer from './beamer';

/**
 * This ensures that chunk loading works on EU and CN production servers
 * Note the differences in the URL endings: "vcom" vs. "zf/vcom"
 * - EU: https://www1.meteocontrol.de/vcom
 * - CN: https://vcom.meteocontrol.cn/zf/vcom
 * @see https://webpack.js.org/guides/public-path/#on-the-fly
 * @param string baseUrl
 */
function initPublicPath(baseUrl) {
  // eslint-disable-next-line
  __webpack_public_path__ = `${baseUrl}/js/`;
}

VcomProvider.PortletConstants = PortletConstants;
VcomProvider.PortletFactoryRegistry = PortletFactoryRegistry;
VcomProvider.PortletPool = PortletPool;
window.HttpService = HttpService;

VcomProvider.init = (settings, executeCapturedJavascript) => {
  initPublicPath(settings.baseUrl);

  VcomProvider.baseUrl = settings.baseUrl;
  VcomProvider.hasLegacyPassword = settings.hasLegacyPassword;
  VcomProvider.systemId = settings.systemId;
  VcomProvider.systemName = settings.systemName;
  VcomProvider.systemTimeZone = settings.systemTimeZone;
  VcomProvider.section = settings.section;
  VcomProvider.pageId = settings.pageId;
  VcomProvider.sspUrl = settings.sspUrl;
  VcomProvider.systemFilters = settings.systemFilters;
  VcomProvider.userTimeZone = settings.userTimeZone;
  VcomProvider.isInvestor = settings.isInvestor;
  VcomProvider.isCustomer = settings.isCustomer;
  VcomProvider.isSuperAdmin = settings.isSuperAdmin;
  VcomProvider.isPartnerAdmin = settings.isPartnerAdmin;
  VcomProvider.isVcomPublic = settings.isVcomPublic;
  VcomProvider.hasSystemConfigRights = settings.hasSystemConfigRights;
  VcomProvider.hasEvaluationAccess = settings.hasEvaluationAccess;
  VcomProvider.showSystemLicenseHint = settings.showSystemLicenseHint;
  VcomProvider.isRegionChina = settings.isRegionChina;
  VcomProvider.isKaco = settings.isKaco;
  VcomProvider.userId = settings.userId;
  VcomProvider.isDevelopmentMode = settings.isDevelopmentMode;
  VcomProvider.automationFrontendSrcBaseUrl = settings.automationFrontendSrcBaseUrl;
  VcomProvider.shouldDisplayAvailabilityEditor = settings.shouldDisplayAvailabilityEditor;

  jQuery(document).ready(async () => {
    TranslationStore.setBaseUrl(settings.baseUrl);
    await TranslationStore.loadTranslations(settings.lang);
    VcomProvider.LanguageSwitch = new LanguageSwitch();
    VcomProvider.LanguageSwitch.init(settings.lang, settings.locale);
    VcomProvider.UpdateService = new UpdateService();
    Base.init();
    VcomProvider.UpdateService.init();
    VcomProvider.Portal = new Portal();
    VcomProvider.Layout = new Layout();
    VcomProvider.Layout.init();
    Base.getSystems();

    const sidebar = new Sidebar();
    sidebar.init(settings.hasEvaluationAccess);
    window.Sidebar = sidebar;

    await vueInstanceSetup();

    executeCapturedJavascript();

    EventService.dispatch(VcomSetupEvent.BASE_INIT_DONE);

    const cyclingSystems = new CyclingSystemsSwitch();
    cyclingSystems.init(settings.cyclingTimeInterval);

    await SocketCenter.connect();

    jQuery('#cycling-systems-control-options').on('click', '.btn-switch-cycling-systems-control-time', (event) => {
      event.preventDefault();
      cyclingSystems.switchCyclingSystemsOption(event.currentTarget.title);
    });

    jQuery('#language-control-options').on('click', '.btnSwitchLanguage', (event) => {
      event.preventDefault();
      VcomProvider.LanguageSwitch.switchLang(event.currentTarget.title);
    });

    jQuery('#cycling-systems-control, #language-control, #help-control, #socket-control, #theme-control, #logged-user-info-control')
      .on('click', (event) => {
        VcomHelperService.closePopupMenus();
        const menu = jQuery(`#${event.currentTarget.id}-options`)
          .addClass('ui-front')
          .show().position({
            my: 'left bottom',
            at: 'left top',
            of: event.currentTarget,
          });
        jQuery(document).one('click', () => {
          if (TourService.isTourActive()) {
            return;
          }
          menu.hide();
        });
        return false;
      });

    jQuery('#cycling-systems-control-options, #language-control-options, #help-control-options, #socket-control-options, #theme-control-options, #logged-user-info-control-options')
      .hide()
      .menu();

    jQuery('#changelog').on('click', () => {
      EventService.dispatch(ChangelogEvent.NOTIFICATION_CLICKED);
    });

    jQuery('#socket-center-reconnect').on('click', () => {
      SocketCenter.connect();
    });
    jQuery('#socket-center-disconnect').on('click', () => {
      SocketCenter.disconnect();
    });

    jQuery('ul.toolbar li').each((index, element) => {
      jQuery(element).on('click', (event) => {
        event.preventDefault();
        window.location.href = jQuery(event.currentTarget).find('a').attr('href');
      });
    });

    localizeHighcharts(settings.decimalSeparator, settings.thousandSeparator);
    localizeDatepicker(Locale.getLanguageCode());
    await mcdatetimepickerInit(Locale.getLanguageCode());

    if (settings.showSystemLicenseExpiringSoonHint) {
      showSystemLicenseEndingSoon(
        translate('javascript.SYSTEM_LICENSE_IS_ENDING_SOON'),
      );
    }

    modals.forEach((modal) => setupModal.init(modal));
    registerModalClickEvents();

    if (settings.hasLegacyPassword) {
      EventService.dispatch('openUserProfileModal');
    }

    // Only initialize after modal click event has been registered
    tourSetup.init();

    addDefaultShortcuts();
    EventService.dispatch('openPartnerInformationModal');

    const jqueryUiDatepickerIconColorTheme = VcomProvider.Layout.getTheme() === 'darkify' ? 'darkify' : '';
    const jqueryUiDatepickerIconName = `jquery-ui-datepicker-icon${jqueryUiDatepickerIconColorTheme !== '' ? '-' : ''}${jqueryUiDatepickerIconColorTheme}`;
    jQuery.datepicker.setDefaults({
      showOn: 'button',
      buttonImage: `${VCOM.baseUrl}/images/${jqueryUiDatepickerIconName}.svg`,
      buttonImageOnly: true,
      buttonText: translate('javascript.LBL_SELECT_DATE'),
    });

    if (settings.error) {
      if (!settings.isInvestor && settings.hasConfigurationRight) {
        noDataloggerInfoWithLink(settings.error, translate('javascript.TX_CLICK_TO_CONFIGURATE'));
      } else {
        noDataloggerInfo(settings.error);
      }
    }

    switch (settings.section) {
      case 'controlRoom':
        if (!jQuery('#header__toolbar .active').length) {
          jQuery('#home-control').addClass('active');
        }
        break;

      case 'analysis':
        jQuery('#analysis-control').addClass('active');
        break;

      case 'calendar':
        jQuery('#calendar-control').addClass('active');
        break;

      case 'reporting':
        jQuery('#reporting-control').addClass('active');
        break;

      default:
    }

    Base.refreshTokens();
    setInterval(Base.refreshTokens, 900000);

    administrationSetup(settings);

    installBeamer();
  });
};
